/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useRef } from 'react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const UserSlideComponent = observer(({ slides }) => {
    // ref
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const breakpoints = {
        480: {
            slidesPerView: 1.2,
            spaceBetween: 16
        },
        576: {
            slidesPerView: 1.2,
            spaceBetween: 16
        },
        640: {
            slidesPerView: 1.3,
            spaceBetween: 30
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    }

    return (
        <div className='users-slide-wrapper'>
            <Swiper
                slidesPerView={1.2}
                spaceBetween={16}
                breakpoints={breakpoints}
                modules={[Pagination, Navigation]}
                pagination={{
                    clickable: true,
                    el: '.custom-pagination-users'
                }}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }}
                onInit={(swiper) => {
                    setTimeout(() => {
                        if (swiper.params?.navigation) {
                            if (typeof swiper.params.navigation !== 'boolean') {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }
                        }
                    });
                }}
                className='swiper-users-voice'
            >
                {
                    Array.isArray(slides) && slides?.length > 0 && slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <UserCard slideItem={slide} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>

            {/* Custom Navigation */}
            <div className='custom-navigation-users'>
                <button
                    ref={prevRef}
                    className='custom-nav-button-users custom-nav-prev-users'
                    aria-label='Previous slide'
                >
                    <ChevronLeft strokeWidth={2.25} color='#4EA953' />
                </button>

                <div className='custom-pagination-users'></div>

                <button
                    ref={nextRef}
                    className='custom-nav-button-users custom-nav-next-users'
                    aria-label='Next slide'
                >
                    <ChevronRight strokeWidth={2.25} color='#4EA953' />
                </button>
            </div>
        </div >
    )
});

export default UserSlideComponent;

const UserCard = ({ slideItem }) => {
    return (
        <div className='user-card'>
            <div className='user-card__img'>
                {/* <img src={slideItem?.image?.url || '/images/img-1.png'} alt='' className='video-card__video' /> */}
                {slideItem?.icon ? slideItem?.icon : (
                    <img src={'/images/img-1.png'} alt='' className='video-card__video' />
                )}
            </div>

            <div className='user-card__desc' style={{ whiteSpace: 'pre-wrap' }}>
                {slideItem?.heading}
            </div>
        </div>
    )
}